// This class handles the hover popups and filling with data for the currency strength meter

export class StrengthMeterHoverController {
  constructor(strMeter) {
    this.strMeter = strMeter;
    this.popup = this.createStrengthMeterPopup();

    this.popup.addEventListener('mouseenter', () => {
      this.popup.classList.remove('d-none');
    });
    if (screen.width < 768) {
      this.popup.addEventListener('click', () => {
        this.popup.classList.add('d-none');
      });
    }
  }

  fillPopup(squareBlock) {
    const childrenData = squareBlock.getChildrenData();
    this.popup.innerHTML = '';
    const popupHeader = document.createElement('DIV');
    popupHeader.innerHTML = squareBlock.name;
    popupHeader.classList.add('popup-header');
    this.popup.append(popupHeader);
    const rowsWrapper = document.createElement('DIV');
    rowsWrapper.classList.add('rows-wrapper');
    childrenData.forEach((cellData) => {
      const rowDiv = document.createElement('DIV');
      rowDiv.classList.add('popup-grid');
      const pairNameDiv = createRowCell(cellData, 'pairName', rowDiv);
      const timeframeDiv = createRowCell(cellData, 'timeFrame', rowDiv);
      const pairChangeDiv = createRowCell(cellData, 'pairChange', rowDiv);
      const pairRateDiv = createRowCell(cellData, 'pairRate', rowDiv);
      rowDiv.append(pairNameDiv);
      rowDiv.append(pairRateDiv);
      rowDiv.append(timeframeDiv);
      rowDiv.append(pairChangeDiv);
      rowsWrapper.append(rowDiv);
    });
    this.popup.append(rowsWrapper);

    function createRowCell(cellData, dataName, rowDiv) {
      const result = document.createElement('DIV');
      result.classList.add(dataName);
      let cellText = cellData[dataName];
      if (dataName == 'pairChange') {
        cellText = parseFloat(cellText).toFixed(2);
        if (cellText < 0) {
          rowDiv.classList.add('negative-text');
        } else {
          rowDiv.classList.add('positive-text');
        }
        cellText = `${cellText}%`;
      } else if (dataName == 'pairRate') {
        cellText = parseFloat(cellText).toFixed(5);
      }
      if (dataName == 'pairName' || dataName == 'timeFrame') {
        rowDiv.dataset[dataName] = cellData[dataName];
      }
      result.innerHTML = cellText;
      return result;
    }
  }

  sortPopup(squareBlock) {
    const blockData = squareBlock.getChildrenData();
    const rowsWrapper = this.popup.querySelector('.rows-wrapper');
    const allRows = this.popup.querySelectorAll('.popup-grid');
    allRows.forEach((row) => {
      blockData.forEach((childData) => {
        if (
          childData.pairName == row.dataset.pairName &&
          childData.timeFrame == row.dataset.timeFrame
        ) {
          rowsWrapper.prepend(row);
          row.classList.add('primary-row');
        } else {
          row.classList.remove('primary-row');
        }
        if (childData.pairName == row.dataset.pairName) {
          row.classList.add('hovered-row');
        } else {
          row.classList.remove('hovered-row');
        }
      });
    });
  }

  createStrengthMeterPopup() {
    //removing old popup if needed
    let popup = this.strMeter.uiDiv.querySelector('.js-heatmap-popup');
    if (!popup) {
      popup = document.createElement('DIV');
      popup.classList.add('heatmap-popup', 'js-heatmap-popup', 'd-none');

      this.strMeter.uiDiv.querySelector('.ui-wrapper').append(popup);
    } else {
      popup.classList.add('d-none');
    }
    return popup;
  }
}
